const PLACEMENT_ROLES = {
  12: {
    name: "START",
    color: [0, 255, 0, 64],
  },
  13: {
    name: "MIDDLE",
    color: [0, 0, 255, 64],
  },
  14: {
    name: "FINISH",
    color: [255, 0, 0, 64],
  },
  15: {
    name: "FOOT",
    color: [255, 255, 0, 64],
  },
// 12 start	Start
// 13 middle	Middle
// 14 finish	Finish
// 15 foot	Foot Only
// 20 start	Start
// 21 middle	Middle
// 22 finish	Finish
// 23 foot	Foot Only
// 24 start	Start
// 25 middle	Middle
// 26 finish	Finish
// 27 foot	Foot Only
// 28 start	Start
// 29 middle	Middle
// 30 finish	Finish
// 31 foot	Foot Only
// 32 start	Start
// 33 middle	Middle
// 34 finish	Finish
// 35 foot	Foot Only
// 42 start	Start
// 43 middle	Middle
// 44 finish	Finish
// 45 foot	Foot Only
}

const START_HOLD = {
  name: "start",
  color: [0, 255, 0, 64],
}
const MIDDLE_HOLD = {
  name: "middle",
  color: [0, 0, 255, 64],
}
const FINISH_HOLD = {
  name: "finish",
  color: [255, 0, 0, 64],
}
const FOOT_HOLD = {
  name: "foot",
  color: [255, 255, 0, 64],
}

const starts = ["12", "20", "24", "28", "32", "42"]
const middles = ["13", "21", "25", "29", "33", "43"]
const finishes = ["14", "22", "26", "30", "34", "44"]
const feet = ["15", "23", "27", "31", "35", "45"]
// const PLACEMENT_ROLES = {
//   // "12": START_HOLD,
//   // "13": MIDDLE_HOLD,
//   // "14": FINISH_HOLD,
//   // "15": FOOT_HOLD,
// }
starts.forEach((start) => {
  PLACEMENT_ROLES[start] = START_HOLD
})
middles.forEach((middle) => {
  PLACEMENT_ROLES[middle] = MIDDLE_HOLD
})
finishes.forEach((finish) => {
  PLACEMENT_ROLES[finish] = FINISH_HOLD
})
feet.forEach((foot) => {
  PLACEMENT_ROLES[foot] = FOOT_HOLD
})

const DEFAULT_ANGLE = 50

export { PLACEMENT_ROLES, DEFAULT_ANGLE }
